module.exports = __webpack_public_path__ + "static/media/dasboarduser1.c3d65b85.jpg";